(function () {
	function init() {
		const blocks = document.querySelectorAll('.nativa-image-lightbox');

		blocks.forEach((block) => {
			const img = block.querySelector('img');
			if (!img) return;

			const images = JSON.parse(block.dataset.images || '[]');

			img.addEventListener('click', () => {
				window.NativaLightbox.open({
					images,
					startIndex: 0,
				});
			});
		});
	}

	document.addEventListener('DOMContentLoaded', init);
})();
